module.exports = __webpack_public_path__ + "media/images/client/MediaReviews/forbes-3aeae394a7480a43a2080b7f9847cecc.svg";